<div class="container">
  <div class="bar-box w-depth">
    <div class="step-name">
      <div class="name">
        {{routeName | translate}}
      </div>
    </div>
  </div>
</div>
